import { render, staticRenderFns } from "./LiveOddsList.vue?vue&type=template&id=7eaa2954&"
import script from "./LiveOddsList.vue?vue&type=script&lang=js&"
export * from "./LiveOddsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports